const FormHelpers = {
    isValidForm: (errors, isTouched) => {
      return (
        Object.keys(errors).length === 0 && Object.keys(isTouched).length > 0
      );
    },
    getValues: (originalValues) => {
      let vals = {
        ...originalValues,
      };
      return vals;
    },
    scrollToTop: () => {
      const pageTop = document.getElementsByClassName("page");
      if(pageTop) {
        window.scrollTo({
          top: pageTop[0].offsetTop,
          behavior: "smooth",
        });
      }
    }
  };
  
  export default FormHelpers;
  